<div class="app-expo-studio"  fxFlex="100%" fxLayout="row wrap">

    <div fxFlex="100%" fxLayoutAlign="start start">
        <h2 class="waiting-room">
            <a role="button" class="back-button" (click)="goBack()"><i class="fa fa-chevron-circle-left"
                    aria-hidden="true"></i></a>
            {{expoInfo?.name}}
            / {{rooms?.skreens_room_name}}
        </h2>
    </div>
    <div class="mobile-rep w-100 d-md-none d-block mb-4">
        <div class="d-flex justify-content-center align-item-center w-100">
            <div class="v-controls-div d-inline-block">
                <div class="v-controls d-inline-block">
                    <a class="c-icons d-inline-block" (click)="soundOff()">
                        <!-- <img [src]="assets_url + 'stream-icons/mic-hover.svg'" id="audioButton" /> -->
                        <span id="audioButton"><app-svg [icon]="audio_icon"></app-svg></span>
                    </a>
                    <a class="c-icons d-inline-block" (click)="vidOff()">
                        <!-- <img [src]="assets_url + 'stream-icons/video-hover.svg'" id="videoButton" /> -->
                        <span id="videoButton">
                            <app-svg [icon]="video_icon"></app-svg>
                        </span>
                    </a>
                    <a class="d-inline-block"><button (click)="disconnect()" class="btn leave-room "> Leave Room</button></a> 
                </div>
               
            </div>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="start start">
        
        <div fxFlex="45%" fxLayout="row wrap" id="screen-share" class="plr-10" [hidden]="!screenShare.isSharedScreen">

        </div>

        <div fxFlex="{{screenShare.isSharedScreen ? '33%' : '80%'}}" fxFlex.xs="100%" fxLayout="row wrap" fxLayoutAlign="center center" class="plr-10 pb-4 video-room relative" id="videoWrapper">

        </div>
        <div fxFlex="20%" fxFlex.xs="100% " fxLayout="row wrap" fxLayoutAlign="center start" class="plr-10">
            <div><div class="pointer">    <div id="RightCarousel" class="carousel slide" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && eventHomeAdsRight && eventHomeAdsRight.length > 0">
                        <div *ngFor="let a of eventHomeAdsRight; let i=index" class="adv-img2 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                        <div class="ad-position">
                            <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                        </div>
                    </ng-container>
                </div>
            </div></div></div>
        </div>
    </div>
    <div class="mobile-rep w-100 d-none d-md-block">
        <div class="d-flex justify-content-center align-item-center w-100">
            <div class="v-controls-div d-inline-block">
                <div class="v-controls d-inline-block">
                    <a class="c-icons d-inline-block" (click)="soundOff()">
                        <!-- <img [src]="assets_url + 'stream-icons/mic-hover.svg'" id="audioButton1" /> -->
                        <span id="audioButton1">
                            <app-svg [icon]="audio_icon"></app-svg>
                        </span>
                    </a>
                    <a class="c-icons d-inline-block" (click)="vidOff()">
                        <!-- <img [src]="assets_url + 'stream-icons/video-hover.svg'" id="videoButton1" /> -->
                        <span id="videoButton1">
                            <app-svg [icon]="video_icon"></app-svg>
                        </span>
                    </a>
                </div>
                <button (click)="disconnect()" class="btn leave-room"> Leave Room</button>
            </div>
        </div>
    </div>
  
</div>
